import React from 'react';
import { isAuthenticated, isOrgAdmin, getLoginURL } from './cognito';

interface Props {
  children: React.ReactNode;
}

export default function RequireOrgAdmin({ children }: Props) {
  if (!isAuthenticated()) {
    return (
      <div style={{ minHeight: '100vh', background: '#0f172a', display: 'flex', alignItems: 'center', justifyContent: 'center', padding: 24 }}>
        <div style={{ maxWidth: 440, textAlign: 'center' }}>
          <div style={{ fontSize: 48, marginBottom: 16 }}>🔒</div>
          <h2 style={{ fontSize: 24, fontWeight: 800, color: '#e2e8f0', marginBottom: 8 }}>Sign in required</h2>
          <p style={{ fontSize: 14, color: '#94a3b8', marginBottom: 28 }}>You need to be signed in to access the team portal.</p>
          <a href={getLoginURL()} style={{ background: 'linear-gradient(135deg,#4f46e5,#7c3aed)', color: 'white', borderRadius: 10, padding: '12px 28px', fontSize: 15, fontWeight: 700, textDecoration: 'none' }}>Sign in</a>
        </div>
      </div>
    );
  }

  if (!isOrgAdmin()) {
    return (
      <div style={{ minHeight: '100vh', background: '#0f172a', display: 'flex', alignItems: 'center', justifyContent: 'center', padding: 24 }}>
        <div style={{ maxWidth: 440, textAlign: 'center' }}>
          <div style={{ fontSize: 48, marginBottom: 16 }}>🚫</div>
          <h2 style={{ fontSize: 24, fontWeight: 800, color: '#e2e8f0', marginBottom: 8 }}>Access restricted</h2>
          <p style={{ fontSize: 14, color: '#94a3b8' }}>The team portal is only available to organisation admins.</p>
        </div>
      </div>
    );
  }

  return <>{children}</>;
}
